export const CORE_CAMERA_DEFAULT = {
  near: 0.1,
  far: 100
};
export var CameraAttribute = /* @__PURE__ */ ((CameraAttribute2) => {
  CameraAttribute2["CONTROLS_PATH"] = "_Camera_controlsPath";
  CameraAttribute2["CSS_RENDERER_PATH"] = "_Camera_CSSRendererPath";
  CameraAttribute2["FRAME_MODE"] = "_Camera_frameMode";
  CameraAttribute2["FRAME_MODE_EXPECTED_ASPECT_RATIO"] = "_Camera_frameModeExpectedAspectRatio";
  CameraAttribute2["POST_PROCESS_PATH"] = "_Camera_postProcessPath";
  CameraAttribute2["RENDER_SCENE_PATH"] = "_Camera_renderScenePath";
  CameraAttribute2["RENDERER_PATH"] = "_Camera_rendererPath";
  return CameraAttribute2;
})(CameraAttribute || {});
export var PerspectiveCameraAttribute = /* @__PURE__ */ ((PerspectiveCameraAttribute2) => {
  PerspectiveCameraAttribute2["FOV"] = "_PerspectiveCamera_fov";
  return PerspectiveCameraAttribute2;
})(PerspectiveCameraAttribute || {});
export var OrthographicCameraAttribute = /* @__PURE__ */ ((OrthographicCameraAttribute2) => {
  OrthographicCameraAttribute2["SIZE"] = "_OrthographicCamera_size";
  return OrthographicCameraAttribute2;
})(OrthographicCameraAttribute || {});
